import { render } from "./ImagePreviewFF.vue?vue&type=template&id=11a27718"
import script from "./ImagePreviewFF.vue?vue&type=script&lang=js"
export * from "./ImagePreviewFF.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\casva\\repos\\cg-vue-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__